import { combineReducers } from 'redux'
import userAccessReducer from './userAccessReducer'

export default combineReducers({
  userAccessReducer,
})
